import styleConstants from './variables.module.scss';
import { Style } from 'utils/types/Style';
import wrapText, { WrappedValue } from 'utils/text/wrapText';

const tickFontFamily = styleConstants.tickFontFamily;
const tickFontSize = styleConstants.tickFontSize;

const MaxWidth = 85;
export const HorizontalPadding = 3;
export const VerticalPadding = 2;

export interface YAxisContext {
    values: string[];
    wrappedValues: WrappedValue[];
    width: number;
    padding: number;
    style: Partial<Style>;
}

export function buildYAxisContext(
    groupNames: string[],
    groupHeight: number
): YAxisContext {
    const context = document.createElement('canvas').getContext('2d')!;
    const style: Partial<Style> = {
        fontFamily: tickFontFamily,
        fontSize: tickFontSize,
    };

    const availableTextWidth = MaxWidth - HorizontalPadding * 2;
    const availableGroupHeight = groupHeight - VerticalPadding;

    const wrappedValues = groupNames.map((v) =>
        wrapText(v, {
            availableLineWidth: availableTextWidth,
            style,
            groupHeight: availableGroupHeight,
            context,
        })
    );

    const maxTextWidth = Math.max(...wrappedValues.map((w) => w.width));
    const maxLineWidth = maxTextWidth + HorizontalPadding * 2;
    const width = Math.round(Math.min(maxLineWidth, MaxWidth));

    const ret = {
        values: groupNames,
        width,
        wrappedValues,
        style,
        padding: HorizontalPadding,
    };

    return ret;
}
